/*
 * @Author: liuzhongyu
 * @Date: 2023-02-14 14:47:31
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-11 10:51:45
 */

import React, { useState, useEffect, useRef } from 'react';
import SupTable from 'sup-rc-table';
import styles from './index.less';
import Modal from 'root/components/CommonModal';
import { Tree, Button, message, Spin } from 'sup-ui';
import { useIntl } from 'react-intl';
import messages from './messages';
import { serverLogDownload } from 'root/services/serviceManage';
import { downloadFiles } from 'root/utils/utils';
import emptyImg from 'root/assets/images/illustrator_notfound@3x.png';

const { TreeNode, DirectoryTree } = Tree;

interface PropsType {
  visible: boolean;
  onOk: (e: any) => void;
  onCancel: (e: any) => void;
  data: any;
}

const ViewLog = (props: PropsType) => {
  const { visible, onOk, onCancel, data } = props;
  const intl = useIntl();
  const [columns, setColumns] = useState<any[]>([]); // 表头数据
  const [selectTree, setSelectTree] = useState<string[]>([]);
  const fileListRef = useRef<any>(null);
  const [selectKeys, setSelectKeys] = useState<any[]>([]);
  const [spinning, setSpinning] = useState(false);

  // 渲染目录
  const renderTreeNodes = (data: any) => {
    return data?.map((item: any) => {
      if (item.id === selectTree[0]) {
        fileListRef.current = item.fileList;
      }
      if (item?.children?.length) {
        return (
          <TreeNode title={item.name} key={item.id} dataRef={item}>
            {renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode title={item.name} key={item.id} {...item} />;
    });
  };

  useEffect(() => {
    setColumns([
      {
        title: intl.formatMessage(messages.logFile),
        width: 300,
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        align: 'left',
      },
      {
        title: intl.formatMessage(messages.operate),
        width: 100,
        align: 'center',
        dataIndex: 'name',
        render: (text: string, record: any) => {
          return (
            <div>
              <a
                className={styles.linkBtn}
                onClick={() => {
                  downloadFile(record);
                }}
              >
                {intl.formatMessage(messages.download)}
              </a>
            </div>
          );
        },
      },
    ]);
    fileListRef.current = [];
    // 设置默认选中第一项
    if (data?.children && data?.children[0]?.id) {
      fileListRef.current = data?.children[0]?.fileList;
      setSelectTree([data?.children[0]?.id]);
    }
  }, [data]);

  // 选择文件
  const treeSelect = (e: string[]) => {
    setSelectTree(e);
  };
  useEffect(() => {}, []);

  // 下载文件
  const downloadFile = (record: any, type?: string) => {
    const { ip, path } = record;
    let params = {
      serviceName: data?.serviceName,
      ip,
      logPaths: [path],
    };

    // 批量下载
    if (type === 'batch') {
      if (!selectKeys.length) message.error(intl.formatMessage(messages.selectNull));

      params = {
        serviceName: data?.serviceName,
        ip: selectKeys[0].ip,
        logPaths: selectKeys.map((item) => item.path),
      };
    }
    setSpinning(true);
    serverLogDownload(params)
      .then((res) => {
        const { data, headers } = res;
        const fileName = headers['content-disposition'].split('filename=')[1];
        downloadFiles(data, fileName);
      })
      .finally(() => {
        setSpinning(false);
      });
  };

  // 选择列表项
  const handleChangeSelectItem = (keys: any[]) => {
    setSelectKeys(keys);
  };

  return (
    <Modal
      title={`${data?.serviceName}${intl.formatMessage(messages.log)} `}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      className={styles.modal}
      width={1000}
    >
      <Spin spinning={spinning}>
        <div className={styles.wrapper}>
          <div className={styles.left}>
            <div className={styles.title}>{data?.serviceName}</div>
            <DirectoryTree onSelect={treeSelect} selectedKeys={selectTree}>
              {renderTreeNodes(data?.children || [])}
            </DirectoryTree>
          </div>
          <div className={styles.right}>
            <div className={styles.allBtn}>
              <Button
                type="primary"
                size="small"
                className={styles.downLoadAll}
                disabled={!selectKeys.length}
                onClick={() => {
                  downloadFile(selectKeys, 'batch');
                }}
              >
                {intl.formatMessage(messages.downLoadALL)}
              </Button>
            </div>
            <div className={styles.dataTable}>
              <SupTable
                controlColumns
                rowKey={(record: any) => record}
                showSearchIcon={false}
                showColumnsFilter={false}
                columns={columns}
                dataSource={fileListRef.current || []}
                selectedRowKeys={selectKeys}
                onSelectItem={handleChangeSelectItem}
                // eslint-disable-next-line react/no-unstable-nested-components
                empty={() => {
                  return (
                    <div style={{ color: '#000', textAlign: 'center' }}>
                      <div>
                        <img src={emptyImg} width="100px" />
                      </div>
                      {intl.formatMessage(messages.empty)}
                    </div>
                  );
                }}
              />
            </div>
          </div>
        </div>
      </Spin>
    </Modal>
  );
};

export default ViewLog;
